import { PRODUCT_TYPES } from '@moal/api'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { PRODUCT_MAP } from '../../constants/products'
import { SiteConfigContext } from '../../context/siteConfigContext'

const LogoIcon = ({ product, size, displayName = false }) => {
  const { productsService } = useContext(SiteConfigContext)

  // see if the source is the product they are in or the hub
  let productIcon = [PRODUCT_MAP.THIS_PRODUCT, PRODUCT_TYPES.HUB]
    .map((key) => productsService[key])
    .find((item) => item.itemNumber.toUpperCase() === product.toUpperCase())

  // if not check other products
  if (!productIcon) {
    productIcon = productsService[PRODUCT_MAP.OTHER_PRODUCTS].find(
      (item) => item.itemNumber.toUpperCase() === product.toUpperCase()
    )
  }

  if (!productIcon) {
    return null
  }

  const classes = () => {
    switch (size) {
      case 'sm':
        return 'h-4 w-4'
      default:
        return 'h-8 w-8'
    }
  }

  return (
    <>
      <img
        className={`${classes()} inline ${
          product.toUpperCase() === 'COMMAND' &&
          'bg-neutral-500 dark:bg-transparent rounded-sm'
        }`}
        src={productIcon?.graphics?.icon?.dark}
        alt={productIcon?.displayName}
      />
      {displayName && <span className="ml-1">{productIcon?.displayName}</span>}
    </>
  )
}

LogoIcon.propTypes = {
  product: PropTypes.string.isRequired,
  size: PropTypes.string,
  displayName: PropTypes.bool
}

export default LogoIcon
